// Browsers pull the print header/footer title from document.title. We can't
// selectively hide just that piece via CSS (it's the browser's own chrome,
// not page content), but we CAN blank the title right before printing and
// restore it once the print dialog closes -- the date/time stamp Chrome
// prints is generated independently, so it still shows.
export function printDocument() {
  const originalTitle = document.title
  document.title = ' '

  const restore = () => {
    document.title = originalTitle
    window.removeEventListener('afterprint', restore)
  }
  window.addEventListener('afterprint', restore)

  window.print()
}
